// extracted by mini-css-extract-plugin
export default {"avatar":"_482eea03a976ef8f","letter":"_10a06e4934eea6f8"};